import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e35c248"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "outer"
};
const _hoisted_2 = { class: "contents change-width" };
const _hoisted_3 = { class: "main" };
import { computed } from 'vue';
import { useMessage } from '@/const/messages';
import MypageMenu from '@/components/organisms/main/mypage/MypageMenu.vue';
import MypageAllocation from '@/components/organisms/main/mypage/MypageAllocation.vue';
import MypageApiManagement from '@/components/organisms/main/mypage/MypageApiManagement.vue';
import MypageMessage from '@/components/organisms/main/mypage/MypageMessage.vue';
import { MYPAGE_DASHBOARD, MYPAGE_API_MANAGEMENT, MYPAGE_MESSAGE, } from '@/components/organisms/main/mypage/types';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean },
        userInfo: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { MYPAGE_MENU } = useMessage();
        const changeTab = (tab) => (store.state.mypageTab = tab);
        const displayTitle = computed(() => {
            if (store.state.mypageTab == MYPAGE_DASHBOARD)
                return MYPAGE_MENU.DASHBOARD;
            if (store.state.mypageTab == MYPAGE_API_MANAGEMENT)
                return MYPAGE_MENU.API_MANAGEMENT;
            if (store.state.mypageTab == MYPAGE_MESSAGE)
                return MYPAGE_MENU.MYPAGE_MESSAGE;
            return MYPAGE_MENU.ALLOCATION;
        });
        const activeComponent = computed(() => {
            if (store.state.mypageTab == MYPAGE_DASHBOARD)
                return MypageAllocation;
            if (store.state.mypageTab == MYPAGE_API_MANAGEMENT)
                return MypageApiManagement;
            if (store.state.mypageTab == MYPAGE_MESSAGE)
                return MypageMessage;
            return MypageAllocation;
        });
        return (_ctx, _cache) => {
            return (props.isAuth)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(MypageMenu, {
                        current: _unref(store).state.mypageTab,
                        class: "menus",
                        onClick: changeTab
                    }, null, 8, ["current"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(activeComponent)), {
                                "display-title": _unref(displayTitle),
                                "user-info": __props.userInfo
                            }, null, 8, ["display-title", "user-info"]))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
